// @flow

import * as React from 'react';
import { Button } from 'reactstrap';

import config from '../../../config';
import { useToggle } from '../../../hooks';
import { addToCart } from '../../../redux/cart';
import type { LodgeOrderData } from '../../../types/invoices';
import CartUpdatedMessageModal from './CartUpdatedMessageModal';
import {
  showPriceAndRooms,
  getFromCookies,
  provideIcon,
  setCookies15Mins,
} from '../helpers';
import { getCustomToast } from '../../../components/ErrorMessage';


type Props = {
  id: string,
  title: string,
  currency: string,
  type: string,
  totalPrice: string,
  inclusions: Array<string>,
  numDays: number,
  RoomNotes: React.ReactElement,
  RoomChargeMessage: React.ReactElement,
  onSuccess: () => void,
  openModal: () => void,
  numRooms: number,
};

export default function Room(props: Props) {
  const {
    id,
    title,
    currency,
    type,
    totalPrice,
    numDays,
    RoomNotes,
    RoomChargeMessage,
    onSuccess,
    openModal,
    numRooms,
  } = props;
  let { inclusions } = props;
  // Remove breakfast filter in new update
  // inclusions = inclusions.filter(s => s && s.toLowerCase() !== 'breakfast');

  const { checkinDate, checkoutDate, pax } = getFromCookies();
  const dateAlreadySelected = checkinDate && checkoutDate;

  const { on, toggle: toggleMessageModal } = useToggle(false);

  const RoomPrice = (
    <span className="room_price">
      <ins>
        {currency} {totalPrice}
      </ins>
    </span>
  );

  const handleAddToCart = async () => {
    try {
      await addToCart({ lodges: [getLodgeApiData()] });
      removePreviousDates();
      toggleMessageModal();
      onSuccess();
    } catch (err) {
      getCustomToast(
        'There seems to be a problem while adding to the cart. Please try again!',
        'error'
      );
    }
  };

  const getLodgeApiData = (): LodgeOrderData => ({
    id,
    pax,
    room_type: type,
    checkin_date: checkinDate,
    checkout_date: checkoutDate,
    meal_plan: config.mealPlan,
    payment_plan: config.paymentPlan,
  });

  function removePreviousDates() {
    setCookies15Mins({ checkinDate: '', checkoutDate: '', pax });
  }

  return (
    <React.Fragment>
      {on && (
        <CartUpdatedMessageModal lodgeId={id} toggle={toggleMessageModal} isOpen={on} />
      )}
      <section className="room__holder">
        <div className="room__name__price">
          <h5 className="room_name">{title}</h5>
          {RoomPrice}
        </div>
        <div className="room__summary">
          <div className="room_detail">
            <div className="room_include_service">
              <h5 className="room_service_title">Included Services</h5>
              <ul className="room_services">
                {inclusions.map(i => (
                  <li key={i}>
                    <i className={provideIcon(i)} /> {i}
                  </li>
                ))}
              </ul>
              <RoomNotes />
            </div>
          </div>
          <div className="room_info">
            <div className="room_pp">
              <span className="room_price_person">
                {showPriceAndRooms(numDays, numRooms)}
              </span>

              {RoomPrice}
              <RoomChargeMessage />
            </div>
            {dateAlreadySelected ? (
              <Button color="yellow" onClick={handleAddToCart} id="lodges-add-to-cart-btn">
                Add to Cart
              </Button>
            ) : (
              <Button color="yellow" onClick={openModal} id="lodges-check-availability-btn">
                Check Availability
              </Button>
            )}
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Lodge/Details/Room.js